exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overviewIcons[data-v-145743cb] {\n  position: absolute;\n  right: 6px;\n  top: 12px;\n}\nspan[data-v-145743cb] {\n  margin-right: 0.4em;\n}\n.fa-bolt[data-v-145743cb] {\n  color: #FF8800;\n}\n.fa-tree[data-v-145743cb], .fa-users[data-v-145743cb] {\n  color: #00B48D;\n}\n.fa-wheelchair[data-v-145743cb] {\n  color: #00BCD4;\n}\n.shadow i[data-v-145743cb] {\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-145743cb","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Activity/OverviewIcons.vue
// module id = 628
// module chunks = 3